import { render, staticRenderFns } from "./DiscoveryPostSelectTable.vue?vue&type=template&id=0eaa1c1f&scoped=true"
import script from "./DiscoveryPostSelectTable.vue?vue&type=script&lang=ts"
export * from "./DiscoveryPostSelectTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eaa1c1f",
  null
  
)

export default component.exports